<template>
    <div class="content">
        <div class="container-fluid">
            <PageTitle :title="$t('CountryList.countryList')">
                <template v-slot:left>
                    <i class="fas fa-globe fa-3x text-billing"/>
                </template>
            </PageTitle>
            <transition mode="out-in" name="fade">
                <APILoading v-if="countries === undefined || countries === null" key="loading" :color="$data.$colors.billing"
                            :text="$t('CountryList.loadingCountries')"/>
                <div v-else key="countries" class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <v-client-table :data="countries" :columns="table.columns" :options="table.options">
                                    <span slot="name" slot-scope="props" v-html="props.row.name" class="font-bold"/>
                                    <img slot="flagURL" slot-scope="props" class="shadow" width="30" alt="flag" :src="getDiceBaseUrl() + props.row.flagURL"/>
                                    <BooleanIcon slot="EU" slot-scope="props" :boolean="props.row.EU"/>
                                </v-client-table>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageTitle from "../../../shared/misc/PageTitle";
import APILoading from "../../../shared/API/APILoading";
import EUFlag from "../../../../assets/images/EU-flag.png";
import BooleanIcon from "../../../shared/misc/BooleanIcon";
import { permissiveFilter } from "../../../../helpers/VueTable";

export default {
    name: "CountryList",
    components: { BooleanIcon, APILoading, PageTitle },
    data() {
        return {
            table: {
                columns: ["name", "alpha2ISO", "alpha3ISO", "numericISO", "flagURL", "EU"],
                options: {
                    sortable: ["name", "alpha2ISO", "alpha3ISO", "numericISO", "EU"],
                    perPage: 10,
                    headings: {
                        name: this.$t("CountryList.name"),
                        alpha2ISO: this.$t("CountryList.alpha2ISO"),
                        alpha3ISO: this.$t("CountryList.alpha3ISO"),
                        numericISO: this.$t("CountryList.numericISO"),
                        flagURL: this.$t("CountryList.flag"),
                        EU: h => h("img", { attrs: { src: EUFlag, width: 30 } }),
                    },
                    orderBy: {
                        column: "name",
                    },
                    filterAlgorithm: {
                        name: (row, query) => permissiveFilter(row.name, query),
                    },
                },
            },
        };
    },
    computed: {
        ...mapGetters("countries", {
            countries: "countries",
        }),
    },
    async created() {
        await this.checkUserAuthentication();
    },
    methods: {
        ...mapActions("user", {
            checkUserAuthentication: "checkUserAuthentication",
        }),
        getDiceBaseUrl() {
            return this.$diceAPI.getBaseUrl();
        },
    },
};
</script>

<style scoped>

</style>